import { isEmpty } from 'lodash'

export function getExameConsideradosTooltipText(exames: string[], title?: string): string {
  if (isEmpty(exames)) return ''
  const actualTitle = title ?? (exames.length > 1 ? 'Exames considerados' : 'Exame considerado')
  return `${actualTitle}:\n${exames.join('\n\n')}`
}
